import i18n from '@/locale';

const deviceType = {
	0: 'Web',
	1: 'App',
	2: 'Game Used',
	3: 'In-App Browser',
	4: 'PWA',
	5: 'Landscape',
};
export default deviceType;